import { useState } from "react";
import {
    Box,
    Stack,
    Paper,
    Typography,
    Avatar,
} from "@mui/material";

import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";

import SettingsSidebar from "../components/settings/SettingsSidebar";

import StoreSettings from "../components/settings/StoreSettings";
import ReceiptSettings from "../components/settings/ReceiptSettings";
import AppearanceSettings from "../components/settings/AppearanceSettings";
import OrderSettings from "../components/settings/OrderSettings";
import UserRolesSettings from "../components/settings/UserRolesSettings";
import BackupSettings from "../components/settings/BackupSettings";
import PrinterSettings from "../components/settings/PrinterSettings";

export default function Settings() {

    const [selectedMenu, setSelectedMenu] = useState("store");

    const renderContent = () => {
        switch (selectedMenu) {
            case "store":
                return <StoreSettings />;

            case "receipt":
                return <ReceiptSettings />;

            case "printer":
                return <PrinterSettings />;

            case "appearance":
                return <AppearanceSettings />;

            case "orders":
                return <OrderSettings />;

            case "users":
                return <UserRolesSettings />;

            case "backup":
                return <BackupSettings />;

            default:
                return <StoreSettings />;
        }
    };

    return (
        <Box sx={{ minHeight: "100vh" }}>

            {/* HEADER */}
            <Stack
                // direction="row"
                // alignItems="center"
                // spacing={2}
                // mb={3}
            >
                {/* <Avatar
                    sx={{
                        bgcolor: "#111",
                        width: 48,
                        height: 48,
                    }}
                >
                    <SettingsRoundedIcon />
                </Avatar> */}

                {/* <Box>
                    <Typography
                        sx={{
                            fontSize: 28,
                            fontWeight: 700,
                        }}
                    >
                        Settings
                    </Typography>

                    <Typography
                        sx={{
                            color: "#777",
                            fontSize: 14,
                        }}
                    >
                        Manage your system preferences
                    </Typography>
                </Box> */}

            </Stack>

            <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={3}
            >
                {/* SIDEBAR */}
                <SettingsSidebar
                    selectedMenu={selectedMenu}
                    setSelectedMenu={setSelectedMenu}
                />

                {/* CONTENT */}
                <Paper
                    elevation={0}
                    sx={{
                        flex: 1,
                        borderRadius: 1.2,
                        border: "1px solid #e5e7eb",
                        p: 4,
                        backgroundColor: "#fff",
                    }}
                >
                    {renderContent()}
                </Paper>
            </Stack>
        </Box>
    );
}